import { useContext } from 'react';

import { ExternalShareContext } from './ExternalShareContext';

export const useWithUserType = () => {
	const { userType } = useContext(ExternalShareContext);
	return { userType };
};
